/* eslint-disable */
import React, { Component } from 'react'
import ProgressBar from '../displays/ProgressBar'
import Modal from '../containers/Modal'
import API from '../../../API'
import ENDPOINTS from '../../../config/endpoints'
import { notify, host } from '../../../helpers'
import { default as axios } from 'axios'

class FileUpload extends Component {
  constructor (props) {
    super(props)
    this.state = {
      progress: 0,
      status: 'Waiting for file',
      file: null,
      filename: null
    }
  }

  selectFile () {
    document.querySelector('#file-picker').click()
  }

  processFile () {
    var file = document.querySelector('input[type=file]').files[0]
    this.setState({filename: file.name, file: file})
  }

  upload () {
    var data = new FormData()
    if (this.props.id) data.append('object_id', this.props.id)
    if (this.props.namespace) data.append('namespace', this.props.namespace)
    data.append('file', this.state.file)
    var config = {
      onUploadProgress: function(progressEvent) {
        this.setState({progress: Math.round( (progressEvent.loaded * 100) / progressEvent.total )})
      }.bind(this)
    }

    axios.post(host.getHTTPBase() + ENDPOINTS.HTTP.STORAGE.UPLOAD, data, config).then(res => {
      if (res.data.success) {
        this.setState({status: 'File uploaded'})
        notify.success('File uploaded')
        this.props.reload(res.data.data)
      }
    }).then((res) => {
      this.resetUpload()
    })
  }

  resetUpload () {
    this.setState({
      progress: 0,
      status: 'Waiting for file',
      modal: false,
      file: null,
      filename: null
    })
    document.querySelector('input[type=file]').value = ''
    this.props.closeModal()
  }
  render () {
    return (
      <span>
      {this.props.displayInline &&
      <span>
        <small>{this.state.filename || this.state.status}</small>
        <ProgressBar percentage={this.state.progress} />
        <span>
          <span className='pull-left'>
            <button className='btn btn-primary btn-sm' onClick={() => this.selectFile()}>Select File</button>
            <input className='hidden' id='file-picker' type='file' onChange={() => this.processFile()} />
          </span>
          <span className='pull-right'>
            <button className={this.state.file ? 'btn btn-sm' : ' hidden'} onClick={() => this.resetUpload()}>Cancel</button>
            <button className={this.state.file ? 'btn btn-primary btn-sm' : ' hidden'} onClick={() => this.upload()}>Upload</button>
          </span>
        </span>
      </span>}

      {!this.props.displayInline &&
      <Modal close={() => this.resetUpload()} isOpen={this.props.modal} title={this.state.filename || 'Pick a file'}
        buttons={[
          { text: 'Select file', event: () => this.selectFile(), hidden: this.state.file },
          { text: 'Cancel', hidden: !this.state.file, event: () => this.resetUpload() },
          { text: 'Upload', hidden: !this.state.file, event: () => this.upload() } ]}>
          <small>{this.state.status}</small>
          <ProgressBar percentage={this.state.progress} />
          <input id='file-picker' type='file' className='hidden' onChange={() => this.processFile()} />
        </Modal>}
      </span>
      )
    }
  }
  export default FileUpload



// WEBPACK FOOTER //
// ./src/components/basic/misc/FileUpload.js